import React from "react";

const HairMaskBenefits = () => {
  return (
    <div className="hairSubServiceWhat">
      <h3>Benefits of Hair Masks</h3>
      <li>
        <h6>Deep Hydration:</h6>
        <p>
          Hair masks replenish moisture in dry and brittle hair, leaving it soft
          and manageable.{" "}
        </p>
      </li>
      <li>
        <h6> Repair and Strengthen:</h6>
        <p>
          They help repair damage caused by heat styling, chemical treatments,
          and environmental factors, strengthening your hair from the roots.
        </p>
      </li>
      <li>
        <h6> Frizz Control:</h6>
        <p>
          Hair masks smooth the hair cuticle, reducing frizz and giving your
          hair a polished, silky finish.
        </p>
      </li>
      <li>
        <h6> Boost Shine:</h6>
        <p>
          Regular use of hair masks restores the natural shine and luster of
          your hair.
        </p>
      </li>
      <li>
        <h6> Promote Hair Growth:</h6>
        <p>
          Nutrient-rich hair masks improve scalp health, stimulate hair
          follicles, and promote healthy growth.
        </p>
      </li>
      <li>
        <h6> </h6>
        <p>
          They create a protective barrier, shielding your hair from future
          damage caused by environmental stressors and styling tools.
        </p>
      </li>
    </div>
  );
};

export default HairMaskBenefits;
